import { defineComponent as _defineComponent } from 'vue'
import type { Contract } from '~/core/components/composed/list/MultipleContracts.vue';

interface Props {
    contracts: Contract[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ContractAddresses',
  props: {
    contracts: { default: () => [] }
  },
  setup(__props: any) {

const { contracts } = __props as { contracts: Contract[] };



return { __sfc: true,contracts }
}

})